import { Component, EventEmitter, Input, Output } from "@angular/core";

import { STRING } from "../../../constants/string";

@Component({
  selector: "med-bubble",
  templateUrl: "./med-bubble.component.html",
  styleUrls: ["./med-bubble.component.scss"],
})
export class MedBubbleComponent {
  @Input() loading = false;
  @Input() visibleCloseBtn = false;
  @Input() styleClass: string = STRING.EMPTY;

  @Output() remove = new EventEmitter<null>();
}
